import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/lms/src/app/event/_components/event-create-form/index.tsx");
